<script>
export default {
	props: {
		itemsLeft: Array,
		itemsRight: Array,
		newItemLeft: Object,
		newItemRight: Object,
		itemsSetLeft: Boolean,
		itemsSetRight: Boolean,
		dataItemLeft: String,
		dataItemRight: String,
		selectLabel: String,
		confirmLabel: String,
	},
	data() {
		return {
			dropdownRef: null,
		};
	},
	computed: {
		isButtonDisabled() {
			return !this.localUrl;
		},
		localUrl() {
			if (this.newItemRight && this.newItemRight.url)
				return this.newItemRight.url;
			return '';
		},
	},
	methods: {
		openDropdown(ref) {
			this.closeDropdown();
			this.dropdownRef = this.$refs[ref];
			if (this.dropdownRef) {
				this.dropdownRef.classList.add('is-active');
				document.addEventListener('click', this.handleDocumentClick);
			}
		},
		closeDropdown() {
			if (this.dropdownRef) {
				this.dropdownRef.classList.remove('is-active');
				document.removeEventListener('click', this.handleDocumentClick);
				this.dropdownRef = null;
			}
		},
		handleDocumentClick(event) {
			if (this.dropdownRef && !this.dropdownRef.contains(event.target)) {
				this.closeDropdown();
			}
		},
		setItemLeft(item) {
			this.$emit('left-item-selected', item);
			this.closeDropdown();
		},
		setItemRight(item) {
			this.$emit('right-item-selected', item);
			this.closeDropdown();
		},
		navigate() {
			this.$emit('navigate');
		},
	},
	beforeDestroy() {
		document.removeEventListener('click', this.handleDocumentClick);
	},
};
</script>

<template>
	<form class="mb-5">
		<div class="field is-grouped is-grouped-multiline mb-0">
			<div class="control is-expanded">
				<div
					class="dropdown is-clickable is-fullwidth"
					ref="dropdownCombinationLeft">
					<button
						class="button is-fullwidth is-justify-content-space-between"
						@click.prevent="openDropdown('dropdownCombinationLeft')">
						<span v-if="newItemLeft">{{ newItemLeft.name }}</span>
						<span v-else>{{ selectLabel }}</span>
						<span class="icon has-text-link is-small">
							<i class="fa-solid fa-chevron-down" aria-hidden="true"></i>
						</span>
					</button>
					<div
						v-if="itemsSetLeft"
						class="dropdown-menu is-fullwidth"
						id="dropdown-combination-left"
						role="menu">
						<div class="dropdown-content is-clipped">
							<a
								v-for="item in itemsLeft"
								:key="'left-' + item.name"
								@click="setItemLeft(item)"
								class="dropdown-item is-flex is-align-items-center">
								<span class="mr-2">{{ item.name }}</span>
								<span
									v-if="dataItemLeft === item.name"
									class="icon has-text-link ml-auto"
									><i class="fa-solid fa-check"></i
								></span>
							</a>
						</div>
					</div>
				</div>
			</div>

			<div class="control is-flex is-align-items-center">
				<span class="icon is-large has-background-primary is-rounded">
					<i class="fa-solid fa-plus fa-xl"></i>
				</span>
			</div>

			<div class="control is-expanded">
				<div
					class="dropdown is-clickable is-fullwidth"
					ref="dropdownCombinationRight">
					<button
						class="button is-fullwidth is-justify-content-space-between"
						@click.prevent="openDropdown('dropdownCombinationRight')">
						<span v-if="newItemRight">{{ newItemRight.name }}</span>
						<span v-else>{{ selectLabel }}</span>
						<span class="icon has-text-link is-small">
							<i class="fa-solid fa-chevron-down" aria-hidden="true"></i>
						</span>
					</button>
					<div
						v-if="itemsSetRight"
						class="dropdown-menu is-fullwidth"
						id="dropdown-combination-right"
						role="menu">
						<div class="dropdown-content is-clipped">
							<a
								v-for="item in itemsRight"
								:key="'right-' + item.name"
								@click="setItemRight(item)"
								class="dropdown-item is-flex is-align-items-center">
								<span class="mr-2">{{ item.name }}</span>
								<span
									v-if="dataItemRight === item.name"
									class="icon has-text-link ml-auto"
									><i class="fa-solid fa-check"></i
								></span>
							</a>
						</div>
					</div>
				</div>
			</div>

			<div class="control">
				<button
					@click.prevent="navigate"
					:class="[
						'button',
						'is-primary',
						{ 'is-disabled': isButtonDisabled },
					]">
					{{ confirmLabel }}
				</button>
			</div>
		</div>
	</form>
</template>
